var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var TrolleyInactive = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "M4.89 20a1.6 1.6 0 0 0 1.61-1.6c0-.89-.72-1.6-1.61-1.6a1.6 1.6 0 0 0-1.61 1.6c0 .88.72 1.6 1.6 1.6Z" }),
    React.createElement("path", { fill: "currentColor", d: "M3.44 3.88 3.17 2H0v1.6h1.78l1.55 11 15.61-1.82L20 4.82 3.44 3.88Zm14.12 7.4-12.9 1.54-1-7.34 14.56.83-.66 4.97Z" }),
    React.createElement("path", { fill: "currentColor", d: "M14.44 20a1.6 1.6 0 0 0 1.62-1.6c0-.89-.73-1.6-1.62-1.6a1.6 1.6 0 0 0-1.6 1.6c0 .88.71 1.6 1.6 1.6Z" }))); });
//# sourceMappingURL=TrolleyInactive.js.map